export const companies = [
  {
    Email: ' E-mail: mohan@givven.com ',
    Name: 'GIVVEN LOGISTICS PRIVATE LIMITED ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1846.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: ' E-mail: rudy@biagl.ie ',
    Name: 'BIA Global Logistics Ltd ',
    Country: 'Ireland ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_13.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ie.svg ',
    FlagAlt: 'Ireland Flag',
  },
  {
    Email: ' E-mail: tejanl@teamglobal.in ',
    Name: 'Teamworld Logistics Pvt. Ltd ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2364.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: ' E-mail: JOAN.LANCHAS@CO-MODALITY.COM ',
    Name: 'Comodality Group ',
    Country: 'Spain ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1375.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/es.svg ',
    FlagAlt: 'DFA PLVS Flag',
  },
  {
    Email: ' E-mail: haris@abm-global.com ',
    Name: 'A B M GLOBAL SHIPPING L.L.C ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2549.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: harvinder@lscfreights.com ',
    Name: 'LSC Freights & Logistics LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_521.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: askar.atlanticlogistics@gmail.com ',
    Name: 'Atlantic Logistics ',
    Country: 'Somali ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2467.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/so.svg ',
    FlagAlt: 'Star icon',
  },
  {
    Email: ' E-mail: Amgad@wfcegypt.com ',
    Name: 'World Freight Center ',
    Country: 'Egypt ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1987.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/eg.svg ',
    FlagAlt: 'Egypt Flag',
  },
  {
    Email: ' E-mail: dxb.tariq@shabourshipping.ae ',
    Name: 'Salim Shabour Shipping LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1944.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: info@massfreight.ae ',
    Name: 'M A S S International Freight LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1275.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: hk@fastoceanshipping.com ',
    Name: 'Fast Ocean Shipping LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1242.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: mohamed.elseidi@relan-eg.com ',
    Name: 'Relan ',
    Country: 'Egypt ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1710.png',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/eg.svg ',
    FlagAlt: 'Egypt Flag',
  },
  {
    Email: ' E-mail: hussain.godil@godilcompanies.com ',
    Name: 'Godil Companies ',
    Country: 'Pakistan ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2751.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/pk.svg ',
    FlagAlt: 'DFA Flag of Pakistan',
  },
  {
    Email: ' E-mail: kiran.sree@mumnet.com ',
    Name: 'M&M Militzer & Münch ',
    Country: 'Algeria ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2392.png',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/dz.svg ',
    FlagAlt: 'Algeria Flag',
  },
  {
    Email: ' E-mail: bdd@lspl.pk ',
    Name: 'Land Star Shipping (Pvt) Ltd. ',
    Country: 'Pakistan ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2188.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/pk.svg ',
    FlagAlt: ' DFA Flag of Pakistan',
  },
  {
    Email: ' E-mail: sudesh.chaturvedi@gac.com ',
    Name: 'Gulf Agency co (Dubai) L.L.C ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2975.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: abhijeet@surecargologistics.com ',
    Name: 'Surecargo Logistics India Pvt. Ltd. ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2257.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: ' E-mail: manodh@alamrishipping.com ',
    Name: 'Alamri Shipping And Logistics LLC ',
    Country: 'Oman ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2667.jpeg ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/om.svg ',
    FlagAlt: 'Oman Flag',
  },
  {
    Email: ' E-mail: maftaab.khatib@cccsa.ch ',
    Name: 'Caspian Container Company SA ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2934.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: ' E-mail: logistics@firstgloballogistics.com ',
    Name: 'Nawlon Egypt',
    Country: 'Egypt ',
    Logo: '/images/templateLogo.png',
    LogoAlt: 'Nawlon Egypt Freight Tool',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/eg.svg ',
    FlagAlt: 'Egypt Flag',
  },
  {
    Email: 'E-mail: harib.j@naqel.com.sa ',
    Name: 'NAQEL Express ',
    Country: 'Saudi Arabia ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1272.jpeg ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: m.khalifa@elkhalifacargo.com ',
    Name: 'Elkhalifa Cargo ',
    Country: 'Egypt ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1850.svg ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/eg.svg ',
    FlagAlt: 'Egypt Flag',
  },
  {
    Email: 'E-mail: admin@greencloudshipping.com ',
    Name: 'Green Cloud Shipping LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_995.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: jasim@expressporter.com ',
    Name: 'Express Porter ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1112.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: brent.m@gallega.com ',
    Name: 'Gallega Global Logistics Single Owner LLC ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_338.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: a.ahmed@globalinklogistics.com ',
    Name: 'Globalink Logistics ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_536.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: yusuf@timeworldfreight.ae ',
    Name: 'Time World Freight ',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1308.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: emmanuel.obuobi@bethelogistics.com ',
    Name: 'Bethel Logistics Company Ltd ',
    Country: 'Ghana ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1854.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/gh.svg ',
    FlagAlt: 'Ghana Flag',
  },
  {
    Email: 'E-mail: NAGARAJ@CARGOCONSOL.IN ',
    Name: 'CARGO CONSOL INDIA PVT LIMITED ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3032.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: 'E-mail: mark.higgins@imperiallogistics.com ',
    Name: 'Imperial Clearing & Forwarding South Africa (Pty) Ltd ',
    Country: 'South Africa ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1697.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/za.svg ',
    FlagAlt: ' Central african republic flag',
  },
  {
    Email: 'E-mail: jitender@promove.in ',
    Name: 'Promove Logistics Pvt. Ltd. ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3147.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: 'E-mail: alefevre@mathezfreight.com ',
    Name: 'Mathez Freight Forwarding ',
    Country: 'France ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_629.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/fr.svg ',
    FlagAlt: 'France Flag',
  },
  {
    Email: 'E-mail: s.sheth@sarjak.com ',
    Name: 'Sarjak Container Lines Pvt. Ltd. ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2605.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: 'E-mail: TEJ@MCC-INDIA.COM ',
    Name: 'MCC CONTAINER LINES PVT LTD ',
    Country: 'India ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3247.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/in.svg ',
    FlagAlt: 'Indian Flag',
  },
  {
    Email: 'E-mail: gm@icmpk.com ',
    Name: 'International Cargo Management (ICM) ',
    Country: 'Pakistan ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3223.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/pk.svg ',
    FlagAlt: 'DFA Flag of Pakistan',
  },
  {
    Email: 'E-mail: Coordinator@logisticsmode.com ',
    Name: 'Logistics Mode (Pvt) Ltd ',
    Country: 'Pakistan ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2484.png ',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/pk.svg ',
    FlagAlt: 'DFA Flag of Pakistan',
  },
  {
    Email: 'E-mail: kalim@qatlog.com',
    Name: 'Qatlog ',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3217.png?hash=1645526466768',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: diana.baltaji@dpworld.com',
    Name: 'DP WORLD LOGISTICS UAE FZE',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_829.png',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: business@wings-waves.com',
    Name: 'Wings & Waves International Cargo LLC',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3378.png',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: althaf.syed@jexgroups.com',
    Name: 'JEX INTERNATIONAL LOGISTICS LLC',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3393.png?hash=1645526581372',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: raja.waseem@chibs-intl.com',
    Name: 'Chibs International Logistics',
    Country: 'Pakistan',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3406.png?hash=1645887545938',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/pk.svg ',
    FlagAlt: 'DFA Flag of Pakistan',
  },
  {
    Email: 'E-mail: leticia@pacificheavens.com',
    Name: 'PACIFIC HEAVENS LOGISTICS CO LTD',
    Country: 'Ghana',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3128.png?hash=1645887573724',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/gh.svg ',
    FlagAlt: 'Ghana Flag',
  },
  {
    Email: 'E-mail: lotus@safeseabd.com',
    Name: 'Safesea Bangladesh Ltd.',
    Country: 'Bangladesh',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1635.png?hash=1645887594616',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/bd.svg ',
    FlagAlt: 'System Run Icon',
  },
  {
    Email: 'E-mail: romi@samuderalautanluas.co.id',
    Name: 'PT. Samudera Lautan Luas',
    Country: 'Indonesia',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1107.png?hash=1645887614005',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/id.svg',
    FlagAlt: 'National Flag',
  },
  {
    Email: 'E-mail: jinu@fncalliance.com',
    Name: 'FNC Alliance Cargo Services LLC',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2881.png?hash=1645887667528',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: minnaz@simamarineafrica.com',
    Name: 'Marine Allianz',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3433.png?hash=1646145724862',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: minnaz@simamarineafrica.com',
    Name: 'Solution Makers International Co',
    Country: 'Saudi Arabia',
    Logo: 'https://www.searates.com/design/images/dfa/cm_1222.png?hash=1646219371757',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/sa.svg',
    FlagAlt: 'Saudi Arabia Flag',
  },
  {
    Email: 'E-mail: z.shazan@masterconsol.com',
    Name: 'MCL SHIPPING LLC',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3466.png?hash=1646663527321',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: vineeth@bjlgulf.com',
    Name: 'Bell And John Logistics',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3435.png?hash=1646663639233',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: mail@seatrans.me',
    Name: 'S E A TRANS SHIPPING LLC',
    Country: 'UAE ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3474.png?hash=1646663574247',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg',
    FlagAlt: 'UAE Flag',
  },
  {
    Email: 'E-mail: info@saamilogistics.com',
    Name: 'Saami Logistics and Transportation Company',
    Country: 'Somali ',
    Logo: 'https://www.searates.com/design/images/dfa/cm_3452.png?hash=1646757379000',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/so.svg ',
    FlagAlt: 'Star icon',
  },
  {
    Name: 'Danube Shipping Management Service GmbH ',
    Country: 'Austria',
    Logo: '/images/template-logo2.jpg',
    LogoAlt: 'Danube managment shipping system',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/at.svg ',
    FlagAlt: "Austria's national flag",
  },
  {
    Name: 'Ceva Logistics',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2030.png?hash=1646816846785',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Name: 'Unico Global Logistics LLC',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_387.png?hash=1646825799817',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
  {
    Name: 'Avem Line Sea Shipping Co LLC ',
    Country: 'UAE',
    Logo: 'https://www.searates.com/design/images/dfa/cm_2711.png?hash=1646835844832',
    Flag: 'https://www.df-alliance.com/images/flags/4x3/ae.svg ',
    FlagAlt: 'UAE Flag',
  },
];